export interface SearchEntry {
  title: string;
  type: "Page" | "Resource" | "FAQ" | "News";
  snippet: string;
  href: string;
}

export const searchIndex: SearchEntry[] = [
  // ── Home Page Sections ──
  {
    title: "About the Fund",
    type: "Page",
    snippet: "The Musicians' Pension Fund of Canada administers pension benefits for eligible members and beneficiaries across Canada. The Fund is governed by a Board of Trustees and supported by the Fund Office.",
    href: "/#about",
  },
  {
    title: "Fund Governance",
    type: "Page",
    snippet: "The Fund is governed by a Board of Trustees including the Chair, Vice-Chair, and Trustees. The mission is to administer the Plan in a prudent manner to ensure long-term viability and the best possible retirement benefits.",
    href: "/#about",
  },
  {
    title: "Summary Plan",
    type: "Page",
    snippet: "A plain-language guide outlining key provisions of the Musicians' Pension Fund of Canada, including eligibility, contributions, benefit calculations, pension options, and distribution rules.",
    href: "/#summary-plan",
  },
  {
    title: "Multi-Employer Pension Plan",
    type: "Page",
    snippet: "The MPF is a multi-employer pension plan for eligible musicians and other eligible members. It is funded through employer contributions made under applicable agreements and administered by a Board of Trustees.",
    href: "/#summary-plan",
  },
  {
    title: "Employer Contributions",
    type: "Page",
    snippet: "Employee contributions are not required or permitted. Employers contribute to the Fund on behalf of eligible members, and those contributions are held in trust to provide benefits and pay Fund administrative expenses.",
    href: "/#summary-plan",
  },
  {
    title: "Pension Benefits Overview",
    type: "Page",
    snippet: "The Plan provides Normal, Early, Deferred, Special Retirement, Disability and Survivor benefits. Pension benefits are not automatic, so members must apply and submit the required forms.",
    href: "/#summary-plan",
  },
  {
    title: "Plan Summary 2019",
    type: "Resource",
    snippet: "Plain-language guide to the Plan and its key provisions. A comprehensive document explaining how the pension plan works, including eligibility and benefit rules.",
    href: "/#summary-plan",
  },
  {
    title: "Plan Rules",
    type: "Page",
    snippet: "The official governing documents of the Musicians' Pension Fund of Canada. They set out the legal terms, eligibility criteria, benefit provisions, and administrative procedures that govern the operation of the Fund.",
    href: "/#plan-rules",
  },
  {
    title: "Plan Rules and Regulations",
    type: "Resource",
    snippet: "The restated Plan text as of January 1, 2018. This is the primary legal document governing the Musicians' Pension Fund of Canada, covering all benefit provisions and administrative rules.",
    href: "/#plan-rules",
  },
  {
    title: "Member Portal",
    type: "Page",
    snippet: "Members can use the secure member portal to access available pension account information, including statements and other member resources. View pension account information, access statements, and use secure self-service access online.",
    href: "/#member",
  },
  {
    title: "Portal Access",
    type: "Page",
    snippet: "Username is the email address on file with MPF Canada. First-time login or forgot password: use Forgot Password on the portal. Need help? Contact the Fund Office.",
    href: "/#member",
  },
  {
    title: "Contact the Fund Office",
    type: "Page",
    snippet: "Reach the Fund Office for questions about your pension, contributions, benefits, member account access, or general Plan information. Located at 200 Yorkland Blvd., Suite 605, Toronto, Ontario M2J 5C1. Phone: 416-497-4702. Toll-free: 1-888-462-6666. Email: info@mpfcanada.ca.",
    href: "/#contact",
  },
  {
    title: "Fund Office Contacts",
    type: "Page",
    snippet: "Reach out directly to the appropriate Fund Office contact: Paul Versteeg-Lytwyn (Executive Director), Lisa DeWitt (Data Processing Manager), Humberto Martins (Director Pension Benefits), Nadia Chamale (Contract Processing), Preesin Doorganah (Assistant, Pension Benefits), Thinn Soe (Assistant to the Executive Director), Wahida Hashem (Receptionist).",
    href: "/#contact",
  },
  {
    title: "Office Hours",
    type: "Page",
    snippet: "The Fund Office is open Monday through Friday, 9:00 AM to 4:00 PM. Located at 200 Yorkland Blvd., Suite 605, Toronto, Ontario M2J 5C1.",
    href: "/#contact",
  },

  // ── Resources Page & Categories ──
  {
    title: "Resources & Documents",
    type: "Page",
    snippet: "Access plan documents, forms, reports, and reference materials for the Musicians' Pension Fund of Canada. Browse categories including Annual Reports, Newsletters, Forms, What Happens If?, and more.",
    href: "/resources",
  },
  {
    title: "Annual Reports",
    type: "Resource",
    snippet: "View the Fund's annual reports from 2013 through 2024. Each report includes financial statements, investment performance, and Plan updates for the Musicians' Pension Fund of Canada.",
    href: "/resources?category=annual-reports",
  },
  {
    title: "2024 Annual Report",
    type: "Resource",
    snippet: "The most recent annual report for the Musicians' Pension Fund of Canada, covering financial results, investment performance, and Plan updates for the 2024 fiscal year.",
    href: "/resources?category=annual-reports",
  },
  {
    title: "Newsletters",
    type: "Resource",
    snippet: "Browse the Fund's newsletter archive from 2003 through 2026. Newsletters provide member updates, Plan changes, and important announcements about the Musicians' Pension Fund of Canada.",
    href: "/resources?category=newsletters",
  },
  {
    title: "Forms",
    type: "Resource",
    snippet: "Download and submit forms for retirement applications, beneficiary designations, address changes, and more. Includes Member Information Change of Beneficiary, Change of Address Notice, and Request for Pension Application.",
    href: "/resources?category=forms",
  },
  {
    title: "Change of Beneficiary Form",
    type: "Resource",
    snippet: "Download the Member Information Change of Beneficiary form to update your designated beneficiary with the Musicians' Pension Fund of Canada.",
    href: "/resources?category=forms",
  },
  {
    title: "Change of Address Notice",
    type: "Resource",
    snippet: "Download the Change of Address Notice form to update your mailing address on file with the Fund Office.",
    href: "/resources?category=forms",
  },
  {
    title: "Request for Pension Application",
    type: "Resource",
    snippet: "Download and submit the Request for Pension Application form to begin the process of applying for your pension benefit from the Fund.",
    href: "/resources?category=forms",
  },
  {
    title: "What Happens If?",
    type: "Resource",
    snippet: "Find answers to common scenarios such as applying for a pension after age 71, changing your beneficiary, becoming disabled, getting divorced, leaving the music business, or working in the U.S.",
    href: "/resources?category=what-happens-if",
  },
  {
    title: "Things You Need to Know",
    type: "Resource",
    snippet: "Important information about filing complaints, inflation and retirement, keeping contact information up to date, contract requirements for leaders, vesting, trustee responsibilities, contributions, applying for a pension benefit, COVID-19 amendments, and ineligible pension contributions.",
    href: "/resources?category=things-you-need-to-know",
  },
  {
    title: "What is Vesting?",
    type: "Resource",
    snippet: "Learn what vesting means for your pension benefit — vesting is when you earn the right to your benefit. You become vested after meeting certain service requirements under the Plan.",
    href: "/resources?category=things-you-need-to-know",
  },
  {
    title: "Keeping Your Contact Information Up to Date",
    type: "Resource",
    snippet: "Why it's important to keep your mailing address, email, and phone number current with the Fund Office so you receive important Plan communications and benefit information.",
    href: "/resources?category=things-you-need-to-know",
  },
  {
    title: "About Applying for a Pension Benefit",
    type: "Resource",
    snippet: "Steps and information about how to apply for your pension benefit from the Musicians' Pension Fund of Canada, including required forms and documentation.",
    href: "/resources?category=things-you-need-to-know",
  },
  {
    title: "Miscellaneous Documents",
    type: "Resource",
    snippet: "Access the Fund's Privacy Policy and General Brochure for additional information about the Musicians' Pension Fund of Canada.",
    href: "/resources?category=miscellaneous",
  },
  {
    title: "Privacy Policy",
    type: "Resource",
    snippet: "The Musicians' Pension Fund of Canada's Privacy Policy, effective January 1, 2004, outlining how member personal information is collected, used, and protected.",
    href: "/resources?category=miscellaneous",
  },
  {
    title: "General Brochure",
    type: "Resource",
    snippet: "A general overview brochure about the Musicians' Pension Fund of Canada, explaining the Plan's purpose, benefits, and how it works for members.",
    href: "/resources?category=miscellaneous",
  },
  {
    title: "Links",
    type: "Resource",
    snippet: "Helpful external links including the Canadian Federation of Musicians and Services Canada for additional pension and employment resources.",
    href: "/resources?category=links",
  },
  {
    title: "RRSP Comparisons",
    type: "Resource",
    snippet: "Compare the Musicians' Pension Fund of Canada plan benefits against RRSP savings, helping members understand the value of their defined benefit pension.",
    href: "/resources?category=rrsp-comparisons",
  },
  {
    title: "SOMEPP Notice",
    type: "Resource",
    snippet: "The Specified Ontario Multi-Employer Pension Plan (SOMEPP) notice explaining the Plan's designation and what it means for members' pension benefits and funding requirements.",
    href: "/resources?category=somepp-notice",
  },
  {
    title: "Key Plan Definitions",
    type: "Resource",
    snippet: "Understanding key plan definitions including covered employment, covered earnings, Year's Maximum Pensionable Earnings, vesting service, and other important Plan terminology.",
    href: "/resources?category=key-plan-definitions",
  },
  {
    title: "Glossary of Terms",
    type: "Resource",
    snippet: "A comprehensive glossary of pension and Plan-related terms to help members understand the language used in Plan documents and communications.",
    href: "/resources?category=key-plan-definitions",
  },

  // ── FAQ Categories & Questions ──
  {
    title: "The Fund and How It Works",
    type: "FAQ",
    snippet: "Learn about the type of Plan, how to join, eligibility requirements, what CFM means, how to become a member, and key Plan definitions for the Musicians' Pension Fund of Canada.",
    href: "/faq#the-fund-and-how-it-works",
  },
  {
    title: "What type of Plan is the Musicians' Pension Fund of Canada?",
    type: "FAQ",
    snippet: "The Plan is a multi-employer defined benefit pension plan, commonly known as a target benefit plan. Benefits are predetermined by a formula based on employer contributions. Accrual rates may be adjusted depending on the Plan's funding status.",
    href: "/faq#the-fund-and-how-it-works",
  },
  {
    title: "How can I join the Plan?",
    type: "FAQ",
    snippet: "You're eligible to become a Plan member if you work for an employer who has entered into a collective bargaining agreement with the Canadian Federation of Musicians (CFM) or has entered into a Participation Agreement with the Trustees.",
    href: "/faq#the-fund-and-how-it-works",
  },
  {
    title: "How can I become a Plan member?",
    type: "FAQ",
    snippet: "You can become a member through 24 months of vesting service, or by having 700 hours of covered employment or covered earnings equal to 35% of the Year's Maximum Pensionable Earnings in a calendar year.",
    href: "/faq#the-fund-and-how-it-works",
  },
  {
    title: "When am I entitled to a pension benefit?",
    type: "FAQ",
    snippet: "You're entitled to a pension benefit once you become vested. Vesting means you have a right to your benefit. You may become vested after meeting service requirements depending on when you joined the Plan.",
    href: "/faq#the-fund-and-how-it-works",
  },

  {
    title: "Pension Benefits FAQ",
    type: "FAQ",
    snippet: "Answers about the types of benefits the Plan pays, pension indexing, Special Retirement pension, Disability pension, how benefits are calculated, beneficiary designation, pension guarantees, early retirement, and working after retirement.",
    href: "/faq#pension-benefits",
  },
  {
    title: "What type of benefits does the Plan pay?",
    type: "FAQ",
    snippet: "The Plan pays Normal pension (starting age 65), Early pension (from age 55), Special Retirement pension, and Disability pension benefits to eligible vested members.",
    href: "/faq#pension-benefits",
  },
  {
    title: "How is my benefit calculated?",
    type: "FAQ",
    snippet: "Your pension is calculated in three parts based on contribution timing: Part 1 (pre-2011), Part 2 (2011-2012), and Part 3 (2013 onwards). Each part uses different accrual rates per $100 of contributions made on your behalf.",
    href: "/faq#pension-benefits",
  },
  {
    title: "Can I retire before age 65?",
    type: "FAQ",
    snippet: "Yes, you can retire as early as age 55 if vested. Your monthly pension payment will be reduced based on your age at retirement — the younger you are, the greater the reduction.",
    href: "/faq#pension-benefits",
  },
  {
    title: "Is my pension indexed after retirement?",
    type: "FAQ",
    snippet: "Only about 32% of defined benefit plans in Canada provide guaranteed indexing after retirement. The Trustees have not implemented guaranteed indexing due to the significant cost. The Board regularly reviews benefit types and makes changes based on members' best interests.",
    href: "/faq#pension-benefits",
  },
  {
    title: "Is my pension guaranteed?",
    type: "FAQ",
    snippet: "No, your pension is not guaranteed. The Ontario Pension Benefits Guarantee Fund does not apply to multi-employer pension plans. In the unlikely event the Plan terminates underfunded, benefits may be subject to reduction.",
    href: "/faq#pension-benefits",
  },
  {
    title: "What is a Disability Pension?",
    type: "FAQ",
    snippet: "You may be eligible for a Disability pension if you become totally and permanently disabled while an active vested member, and are not eligible to receive disability benefits from your employer or an employer-provided insurance program.",
    href: "/faq#pension-benefits",
  },
  {
    title: "Who can be my beneficiary?",
    type: "FAQ",
    snippet: "Your beneficiary is any person you designate to receive Plan benefits if you die. If you have a spouse when your retirement starts, they are automatically your beneficiary unless you both waive that right in writing.",
    href: "/faq#pension-benefits",
  },

  {
    title: "Death Benefits FAQ",
    type: "FAQ",
    snippet: "What happens to your pension benefit if you die before or after you start receiving your benefit, including pre-retirement death benefits and survivor benefits for your beneficiary.",
    href: "/faq#death-benefits",
  },
  {
    title: "What happens to my pension benefit if I die before I retire?",
    type: "FAQ",
    snippet: "If you are vested and die before retirement, your beneficiary will receive a pre-retirement death benefit from the Plan. If you are not vested, no benefit is payable.",
    href: "/faq#death-benefits",
  },
  {
    title: "What happens to my pension benefit if I die after I start receiving my benefit?",
    type: "FAQ",
    snippet: "If you die after starting your pension, your beneficiary may receive a benefit depending on the payment form you selected at retirement. Contact the Fund Office at 1-888-462-6666 for details.",
    href: "/faq#death-benefits",
  },

  {
    title: "Contribution Information FAQ",
    type: "FAQ",
    snippet: "How pension contributions are made, whether you can make your own contributions, rules about negotiated fees, contribution rate limits, working outside Canada, leaves of absence, T4 reporting, and working while receiving a pension.",
    href: "/faq#contribution-information",
  },
  {
    title: "How are pension contributions made to the Fund?",
    type: "FAQ",
    snippet: "Pension contributions are made on your behalf by your employers based on your dates of employment and scale wages. Contributions are held in a trust fund to provide benefits to eligible members and beneficiaries.",
    href: "/faq#contribution-information",
  },
  {
    title: "Can I make my own pension contributions?",
    type: "FAQ",
    snippet: "No, employee contributions are not required or permitted. The Income Tax Act requires a bona fide employer-employee relationship for every member who participates in the registered pension plan.",
    href: "/faq#contribution-information",
  },
  {
    title: "If I work outside Canada, do I continue getting pension contributions?",
    type: "FAQ",
    snippet: "If temporarily working outside Canada for a Canadian employer, contributions can continue. Working in the US for a US employer may also qualify. Both the Canadian and US plans have reciprocal recognition provisions for eligibility and vesting.",
    href: "/faq#contribution-information",
  },

  {
    title: "Life Events FAQ",
    type: "FAQ",
    snippet: "What to do when preparing for retirement, getting married or divorced while receiving a pension, and marriage breakdown calculations.",
    href: "/faq#life-events",
  },
  {
    title: "What should I do when I am preparing for retirement?",
    type: "FAQ",
    snippet: "Notify the Fund Office at least three months before your intended retirement date. A retirement application and instructions will be mailed or emailed to you. Submit proof of age, marital status, and complete the necessary forms.",
    href: "/faq#life-events",
  },
  {
    title: "What happens if I get divorced before or while receiving my pension benefit?",
    type: "FAQ",
    snippet: "The benefit your former spouse may receive depends on applicable law and court documents or agreements. File any court documents with the Fund Office as soon as possible. Your benefit may be adjusted accordingly.",
    href: "/faq#life-events",
  },

  {
    title: "General FAQ",
    type: "FAQ",
    snippet: "How to check your account information through the Member Portal and how contributions to the Fund are invested in a diversified portfolio managed by professional investment managers.",
    href: "/faq#general",
  },
  {
    title: "How can I check my account information?",
    type: "FAQ",
    snippet: "Visit the MPF Canada Member Portal to see employer contributions. Your username is your email on file. Use the Forgot Password feature if logging in for the first time. Call the Fund Office at 1-888-462-6666 for assistance.",
    href: "/faq#general",
  },
  {
    title: "How are contributions to the Fund invested?",
    type: "FAQ",
    snippet: "Contributions are invested in a diversified portfolio of assets managed by professional investment managers. Plan assets are held in trust by an independent custodian in compliance with pension legislation. See the Annual Reports for details.",
    href: "/faq#general",
  },

  // ── News Items ──
  {
    title: "Changes to the Board of Trustees",
    type: "News",
    snippet: "NOV 2025 — Eddy Bayens retires from the Board after 20+ years. Bernard LeBlanc appointed Vice-Chair. David Owen welcomed as new Employee Trustee.",
    href: "/news",
  },
  {
    title: "Passing of Jill Giustino, Executive Director",
    type: "News",
    snippet: "JAN 2025 — Official announcement of the passing of Jill Giustino, Executive Director of the Musicians' Pension Fund of Canada.",
    href: "/news",
  },
  {
    title: "Extension to Recent Plan Amendment",
    type: "News",
    snippet: "JAN 2021 — Official notice regarding the extension to a recent Plan amendment affecting the Musicians' Pension Fund of Canada.",
    href: "/news",
  },
  {
    title: "COVID-19 Pandemic and Financial Market Volatility",
    type: "News",
    snippet: "APR 2020 — The Fund's official COVID-19 update addressing the pandemic's impact on financial markets and the Plan, with related questions and answers for members.",
    href: "/news",
  },
  {
    title: "2019 Announcement",
    type: "News",
    snippet: "FEB 2019 — Official announcement from the Musicians' Pension Fund of Canada regarding Plan updates and member information.",
    href: "/news",
  },
  {
    title: "Quebec Bill 34 Update",
    type: "News",
    snippet: "Updates from 2015 and 2016 regarding Quebec Bill 34 and its impact on the Musicians' Pension Fund of Canada and Quebec-based Plan members.",
    href: "/news",
  },
  {
    title: "GMMQ Referendum on Disaffiliation",
    type: "News",
    snippet: "MAY 2014 — Trustee response to the Guilde des Musiciens et Musiciennes du Québec referendum on disaffiliation from the AFM, addressing member concerns about continued Plan participation.",
    href: "/news",
  },
  {
    title: "2013 Results Strong; Fund Challenges Continue",
    type: "News",
    snippet: "JAN 2014 — The Plan achieved an 18% investment return in 2013 with assets growing to $675M, while acknowledging ongoing funding challenges for the Musicians' Pension Fund.",
    href: "/news",
  },
  {
    title: "FAQ Questions Benefit Changes 2013",
    type: "News",
    snippet: "JAN 2013 — Questions and answers about the Plan changes effective January 1, 2013, explaining new contribution rules and benefit calculations for members.",
    href: "/news",
  },
  {
    title: "Notice of Plan Changes December 2012",
    type: "News",
    snippet: "DEC 2012 — Announcement of Plan changes effective January 1, 2013 to comply with provincial funding requirements. Changes only affect contributions on a go-forward basis.",
    href: "/news",
  },
  {
    title: "Kinross Class Action",
    type: "News",
    snippet: "MAR 2012 — The Trustees of the Musicians' Pension Fund of Canada are plaintiffs in a shareholder class action against Kinross Gold Corporation and senior management in Ontario Superior Court.",
    href: "/news",
  },
  {
    title: "SOMEPP Election Notice",
    type: "News",
    snippet: "JAN 2009 — The Trustees filed an election to have the Fund designated as a Specified Ontario Multi-Employer Pension Plan (SOMEPP) for temporary relief from solvency funding requirements.",
    href: "/news",
  },
  {
    title: "Volatility in the Stock Markets",
    type: "News",
    snippet: "OCT 2008 — Trustee message about market volatility, reassuring members that the Fund is monitored closely and managed for long-term health and security of the pension promise.",
    href: "/news",
  },
  {
    title: "Disability Pension Notice",
    type: "News",
    snippet: "DEC 2007 — Plan members applying for a disability pension after January 1, 2008 will be ineligible if they can receive disability benefits from their employer or employer insurance.",
    href: "/news",
  },
  {
    title: "2008 Financial Crisis Update",
    type: "News",
    snippet: "OCT 2008 — Trustees address concerns about stock market volatility, confirming the Fund is diversified and managed for the long term with a history of weathering market cycles.",
    href: "/news",
  },
];

export function searchContent(query: string): SearchEntry[] {
  if (!query || query.trim().length === 0) return [];

  const terms = query.toLowerCase().trim().split(/\s+/);

  return searchIndex
    .map((entry) => {
      const titleLower = entry.title.toLowerCase();
      const snippetLower = entry.snippet.toLowerCase();
      const typeLower = entry.type.toLowerCase();

      let score = 0;

      for (const term of terms) {
        // Exact title match = highest weight
        if (titleLower === term) score += 10;
        // Title contains term
        else if (titleLower.includes(term)) score += 5;
        // Term at start of a word in title
        else if (new RegExp(`\\b${term}`).test(titleLower)) score += 3;

        // Snippet contains term
        if (snippetLower.includes(term)) score += 2;

        // Type matches
        if (typeLower.includes(term)) score += 1;
      }

      return { entry, score };
    })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .map(({ entry }) => entry);
}